import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import EngineeringIcon from '@mui/icons-material/Engineering';
import { Typography, Container, Grid } from '@mui/material';
import i18next from 'i18next';

import useTypedSelector from 'hooks/useTypedSelector';
import { contactSettingsSelector } from 'redux/selectors/contactSettings.selector';
import { sendContactEmailRequest, resetContactStatus } from 'redux/actions/contactSettings.actions';

import ContactView from 'views/public/ContactView';
import Loading from 'components/commons/Loading';

import { IContactFormData } from 'views/public/ContactView/types';
import { MaintenanceWrapper, ContentCard, IconWrapper, ContactSection } from './styles';
import './i18n';

const MaintenancePage: React.FC = () => {
  const dispatch = useDispatch();
  const { loading, success } = useTypedSelector(contactSettingsSelector);

  useEffect(() => {
    return () => {
      dispatch(resetContactStatus());
    };
  }, [dispatch]);

  const onSubmit = (formData: IContactFormData) => dispatch(sendContactEmailRequest(formData));

  return (
    <MaintenanceWrapper>
      <Container maxWidth="md">
        <ContentCard>
          <Grid container spacing={4} alignItems="center">
            <Grid item xs={12} md={6}>
              <IconWrapper>
                <EngineeringIcon sx={{ fontSize: 80 }} />
              </IconWrapper>
              <Typography variant="h3" gutterBottom fontWeight="800">
                {i18next.t<string>('MAINTENANCE_PAGE:TITLE')}
              </Typography>
              <Typography variant="h6" color="textSecondary" paragraph>
                {i18next.t<string>('MAINTENANCE_PAGE:SUBTITLE')}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                {i18next.t<string>('MAINTENANCE_PAGE:PATIENCE_TEXT')}
              </Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <ContactSection>
                <Typography variant="h5" gutterBottom fontWeight="600">
                  {i18next.t<string>('MAINTENANCE_PAGE:CONTACT_TITLE')}
                </Typography>
                <Typography variant="body2" sx={{ mb: 3 }}>
                  {i18next.t<string>('MAINTENANCE_PAGE:CONTACT_SUBTITLE')}
                </Typography>
                <ContactView onSubmit={onSubmit} success={success} fullWidth />
                {loading && <Loading isModalMode message={i18next.t('CONTACT:LOADING')} />}
              </ContactSection>
            </Grid>
          </Grid>
        </ContentCard>
      </Container>
    </MaintenanceWrapper>
  );
};

export default MaintenancePage;
